import { Text } from "react-native";
import { AtomsView } from "ui";
import { Button } from "ui/gluestack/button";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import {
  emailValidation,
  maxLengthValidation,
  minLengthValidation,
  requiredValidation,
  validationSchema,
} from "ui/utils/Validators";
import { LoginRequest } from "app/services/api/types/authorisation/requests/LoginRequest";
import { AccountRecoveryPath } from "app/constants/routePaths";

import { Link } from "expo-router";
import { useLogin } from "../hooks/useLogin";
import Card from "../atoms/Card";
import { CardLogo } from "../atoms/CardLogo";

export default function LoginForm() {
  const { control, submitForm, isLoading } = useLogin();

  return (
    <AtomsView className="flex-1 justify-center items-center w-full bg-white">
      <Card>
        <CardLogo />
        <Text className="font-semibold text-xl">Log in</Text>
        <FormControlledInput<LoginRequest>
          id="login-email"
          name="email"
          control={control}
          label={"Email"}
          placeholder={"Enter your email"}
          isRequired
          isDisabled={isLoading}
          rules={{
            maxLength: maxLengthValidation(validationSchema.email.maxLength),
            minLength: minLengthValidation(validationSchema.email.minLength),
            required: requiredValidation("Email"),
            validate: {
              emailValidation,
            },
          }}
          onSubmitEditing={submitForm}
        />
        <FormControlledInput<LoginRequest>
          id="login-password"
          name="password"
          control={control}
          type="password"
          label={"Password"}
          placeholder={"Enter your password"}
          isRequired
          isDisabled={isLoading}
          rules={{
            required: requiredValidation("Password"),
          }}
          onSubmitEditing={submitForm}
        />
        <Button onPress={submitForm} action="primary" isDisabled={isLoading}>
          <Text className="text-white">Log in</Text>
        </Button>
        <Link
          className="self-center h-8 justify-center"
          href={AccountRecoveryPath}
        >
          <Text className="text-typography-500 hover:underline">
            Forgot password
          </Text>
        </Link>
      </Card>
    </AtomsView>
  );
}
